import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from "environments/environment";
import { AlertResponse } from "app/core/models/alert-response";
import { AlertGeneratedResponse } from "app/core/models/alert-generated-response";

@Injectable()
export class AlertService {

  constructor(private readonly _httpClient: HttpClient) { }

  public getAlerts(filter: string, sortDirection: 'asc' | 'desc'| '', sortField: string, 
                      pageIndex: number, pageSize: number, activeFilters: Object[]): Observable<AlertResponse> {
    
    let allStringFilterAux = [];
    activeFilters.forEach((item, index) => {
      if (item['value'] != null && item['value'] != '') {
        let stringFilterAux = [item['id'],item['value']];
        allStringFilterAux.push(stringFilterAux.join('::'));
      }
    });

    let queryFilter = allStringFilterAux.join('--');

    
    let params = new HttpParams()
    .set('page', pageIndex.toString())
    .set('page_size', pageSize.toString())
    .set('sf', sortField?.toString() ? sortField?.toString() : '')
    .set('s', sortField?.toString() ? sortDirection?.toString().toUpperCase() : '')
    .set('f', queryFilter);

    return this._httpClient.get(`${environment.apiUrl}/alert_configurations`, {
      params: params
      }).pipe(
          
          map(res =>  <AlertResponse>res)
      );
  }

    public getGeneratedAlerts(filter: string, sortDirection: 'asc' | 'desc'| '', sortField: string, 
                      pageIndex: number, pageSize: number, activeFilters: Object[], idElement: string = null): Observable<AlertGeneratedResponse> {
    
    let allStringFilterAux = [];
    activeFilters.forEach((item, index) => {
      if (item['value'] != null && item['value'] != '') {
        let stringFilterAux = [item['id'],item['value']];
        allStringFilterAux.push(stringFilterAux.join('::'));
      }
    });

    let queryFilter = allStringFilterAux.join('--');

    
    let params = new HttpParams()
    .set('page', pageIndex.toString())
    .set('page_size', pageSize.toString())
    .set('sf', sortField?.toString() ? sortField?.toString() : '')
    .set('s', sortField?.toString() ? sortDirection?.toString().toUpperCase() : '')
    .set('f', queryFilter);

    return this._httpClient.get(`${environment.apiUrl}/alert_configurations/${idElement}/alerts`, {
      params: params
      }).pipe(
          
          map(res =>  <AlertGeneratedResponse>res),
          map((res) => {
            res.data.map((dataEl) => {
              let image = new Image();
              image.src = 'data:image/png;base64,'+ dataEl.message.content.image;
              dataEl.message.content['image_width'] = image.width;
              dataEl.message.content['image_height'] = image.height;
              return dataEl;
            })
            return res;
        })
      );
  }


  getAlertStatus(): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/alert_configurations/status`);
  }

  getAlertSource(): Observable < any > {
    return this._httpClient.get(`${environment.apiUrl}/alert_configurations/source`);
}

  getAlertsList(): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/alert_configurations`);
  }

  getAlert(id: string): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/alert_configurations/${id}`);
  }

  createAlert(alert: any): Observable < any > {
      return this._httpClient.post(`${environment.apiUrl}/alert_configurations`, alert);
  }

  editAlert(alert: any, id: string): Observable < any > {
      return this._httpClient.put(`${environment.apiUrl}/alert_configurations/${id}`, alert);
  }

  deleteAlert(id: string): Observable < any > {
      return this._httpClient.delete(`${environment.apiUrl}/alert_configurations/${id}`);
  }
  
}
